export { HomePage } from './HomePage'
export { NoticiasPage } from './NoticiasPage'
export { BibliotecaPage } from './BibliotecaPage'
export { LegislacaoPage } from './LegislacaoPage'
export { DocumentosPage } from './DocumentosPage'
export { DuvidasPage } from './DuvidasPage'
export { NoticiaIndividualPage } from './NoticiaIndividualPage' 